export enum TicketStatus {
    ON_GOING = 'ON_GOING',
    PENDING_CLOSURE = 'PENDING_CLOSURE',
    CLOSED = 'CLOSED'
}